/**
 * @param  {import('./maps-model').MapResult} mapResult
 */
export const getContactDataFromMapResult = (mapResult) => {
  return {
    name: mapResult?.name,
    address1: mapResult?.formatted_address,
    city: getAddressLongName(mapResult, 'administrative_area_level_1'),
    postalcode: getAddressLongName(mapResult, 'postal_code'),
    country: getAddressLongName(mapResult, 'country') ,
    phone: mapResult?.international_phone_number,
    url: mapResult?.website,
  };
}

/**
 * @param  {import('./maps-model').MapResult} mapResult
 */
const getAddressLongName = (mapResult, key) => {
  return mapResult?.address_components?.find((e) => e?.types?.includes(key))?.long_name || '';
}